
import CTNButton from '@ctn/ui/components/ctn-button';
import CTNMessage from '@ctn/ui/components/ctn-message';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGlobalContext } from '@/context/global.context';

import { type FormValues } from '@/interfaces/model/don.interface';

import { messageBody } from '../const/constants';

const SeleccionDeFormato = () => {
	const { setValue, watch } = useFormContext<FormValues>();
	const firmaTelematica = watch('firmaTelematica');	
	const {
		maestrosTramite: { configuracionTramite },
	} = useGlobalContext();

	useEffect(() => {
		if (!configuracionTramite?.permiteFirmaTelematica) {
			setValue('firmaTelematica', false, { shouldDirty: true });
		}
	}, [configuracionTramite?.permiteFirmaTelematica, setValue]);
    
	return (
		<div className="c-pnp-type-sign">
			<p className='c-pnp-heading-h4  u-mt-24'>
				Selecciona el tipo de firma deseado
			</p>
			{!configuracionTramite?.permiteFirmaTelematica && (<CTNMessage
				closable={false}
				content="Esta solicitud solo permite la selección de convocatoria presencial." 
				className='[ u-mt-16 ]'
				icon="info" 
				mode="outline"
				status="warning"
			/>)}
			<div className="c-pnp-type-sign__btn-group [ u-mt-16 ]">
				<CTNButton
					className={`c-pnp-type-sign__btn ${firmaTelematica ? '' : 'c-pnp-type-sign__btn--selected'}`}
					icon={[{
						icon:'realstate',
						color: `${firmaTelematica ? 'gray-70' : 'blue-50'}`,
					}]}
					label="Presencial"
					mode="primary"
					variant="ghost"
					size="lg"
					onClick={() => setValue('firmaTelematica', false, { shouldDirty: true })}
				/>
				{configuracionTramite?.permiteFirmaTelematica && (
					<CTNButton
						className={`c-pnp-type-sign__btn ${firmaTelematica ? 'c-pnp-type-sign__btn--selected' : ''}`}
						icon={[{
							icon:'telesign',
							color: `${firmaTelematica ? 'blue-50' : 'gray-70'}`,
						}]}
						label="Videoconferencia"
						mode="primary"
						variant="ghost"
						size="lg"
						onClick={() => setValue('firmaTelematica', true, { shouldDirty: true })}
					/>
				)}
			</div>
			{configuracionTramite?.permiteFirmaTelematica && firmaTelematica && (<CTNMessage
				closable={false}
				className='[ u-mt-24 ]'
				content={messageBody} 
				icon="info" 
				mode="outline"
				status="info"
			/>)}
		</div>
	);
};

export default SeleccionDeFormato;
